import { animate } from 'animejs';

const accordions = document.querySelectorAll('.accordion');

accordions.forEach((el) => {
    const trigger = el.querySelector('.accordion-trigger');
    const content = el.querySelector('.accordion-content');
    const icon = el.querySelector('.accordion-icon');

    if (!content) {
        return;
    }
    console.log(trigger)

    content.style.maxHeight = '0px';

    trigger.addEventListener('click', () => {
        if (el.classList.contains('open')) {
            // Close current accordion
            content.style.maxHeight = content.scrollHeight + 'px';
            requestAnimationFrame(() => {
                content.style.maxHeight = '0px';
            });

            // Animate icon back to 0deg immediately
            animate(icon, {
                rotate: 0,
                duration: 300,
                easing: 'linear'
            });

            // Remove open class after content collapsed
            const handleTransitionEnd = () => {
                el.classList.remove('open');
                content.removeEventListener('transitionend', handleTransitionEnd);
            };
            content.addEventListener('transitionend', handleTransitionEnd);

        } else {
            // Close others
            accordions.forEach((other) => {
                if (other !== el && other.classList.contains('open')) {
                    const otherContent = other.querySelector('.accordion-content');
                    const otherIcon = other.querySelector('.accordion-icon');

                    otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        otherContent.style.maxHeight = '0px';
                    });

                    // Animate other icon back to 0deg immediately
                    animate(otherIcon, {
                        rotate: 0,
                        duration: 300,
                        easing: 'linear'
                    });

                    const handleOtherTransitionEnd = () => {
                        other.classList.remove('open');
                        otherContent.removeEventListener('transitionend', handleOtherTransitionEnd);
                    };
                    otherContent.addEventListener('transitionend', handleOtherTransitionEnd);
                }
            });

            // Open clicked accordion
            el.classList.add('open');
            content.style.maxHeight = content.scrollHeight + 'px';

            // Animate icon to 45deg immediately
            animate(icon, {
                rotate: 45,
                duration: 300,
                easing: 'linear'
            });
        }
    });
});
